import React, { Component } from 'react';
import { Modal, Input, Button, Timeline } from 'antd';
import moment from 'moment'
import './style.scss'
const { TextArea } = Input;
class Remarks extends Component {
    constructor() {
        super();
        this.state = {
            hasError: false,
            loading: false,
            content: '',
        };
    }
    componentDidMount() {
        const { _getRemarks } = this.props;

        _getRemarks();
    }

    onCancel = () => {
        const { onCancel } = this.props
    }
    //确认备注
    send = async () => {
        const { currentAgent, onOk } = this.props
        if (this.state.hasError) {
            return
        }
        onOk(this.state.content);
        this.setState({ content: '' });
    }

    onChangeVal = (val) => {
        this.setState({ content: val });
    }

    render() {
        const { isShow = false, data = [], onCancel, onOk } = this.props;
        return (
            <Modal
                width={'60%'}
                visible={isShow}
                title="备注"
                centered={true}
                closable={true}
                maskClosable={false}
                wrapClassName={'leave-message-modal'}
                onCancel={onCancel}
                footer={[

                    <Button id="addLeaveMsg" key="submit" className="leaveMsgBtn" loading={this.state.loading} disabled={this.state.hasError} type="primary" onClick={this.send}
                        style={{ position: 'absolute', bottom: '14px', right: '20px' }}
                        disabled={this.state.content.length == 0}
                    >
                        添加备注
                    </Button>,
                ]}>
                <div style={{ maxHeight: '60%', overflowY: 'scroll', padding: '5px', display: 'flex' }}>
                    <div style={{ width: '60%', overflowY: 'scroll', paddingTop: 10, }}>
                        <Timeline>
                            {
                                data.map(item => {
                                    return <Timeline.Item key={item._id} color="green" >{moment(item.createdAt).format('YY-MM-DD HH:mm:ss')}  {item.agentName} <br />{item.content}</Timeline.Item>
                                })
                            }
                        </Timeline>
                    </div>
                    <div style={{ width: '40%' }}>
                        <div className={this.state.hasError ? 'leave-message-error' : 'leave-message-error-hide'}>请输入备注内容</div>
                        <TextArea id="input_leaveMsg" rows={16} onChange={(e) => this.onChangeVal(e.target.value)} value={this.state.content} placeholder="请输入备注内容"
                            style={{ border: 'none', outline: 'none' }}
                        />
                    </div>


                </div>
            </Modal>
        )
    }
}
export default Remarks;